import { useSelector } from '@xstate5/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useSessionRetryAt = () => {
  const { authMachineRef } = useEssentialMachines();

  return useSelector(authMachineRef, (state) => state.context.sessionRetryAt);
};
